var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCursorClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3D900",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 26.727L22.273 21 21 22.273 26.727 28 21 33.727 22.273 35 28 29.273 33.727 35 35 33.727 29.273 28 35 22.273 33.727 21 28 26.727z",
    fill: "#170F4F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9IiNFM0Q5MDAiIC8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICBkPSJNMjguMDAwMSAyNi43Mjc0TDIyLjI3MjcgMjFMMjEgMjIuMjcyN0wyNi43Mjc0IDI4LjAwMDFMMjEuMDAwMSAzMy43Mjc0TDIyLjI3MjggMzUuMDAwMUwyOC4wMDAxIDI5LjI3MjhMMzMuNzI3MyAzNUwzNSAzMy43MjczTDI5LjI3MjggMjguMDAwMUwzNS4wMDAxIDIyLjI3MjhMMzMuNzI3NCAyMS4wMDAxTDI4LjAwMDEgMjYuNzI3NFoiCiAgICBmaWxsPSIjMTcwRjRGIiAvPgo8L3N2Zz4=";
export { SvgCursorClose as ReactComponent };